import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}

import { ref, computed } from 'vue';

type DisplayPropertySize = 'small' | 'medium';
interface Props {
  label: string
  value: string,
  loading?: boolean,
  loaderWidth?: string,
  horizontal?: boolean,
  size?: DisplayPropertySize,
  noTruncate?: boolean,
  elipsizedTooltip?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayProperty',
  props: {
    label: {},
    value: {},
    loading: { type: Boolean },
    loaderWidth: {},
    horizontal: { type: Boolean, default: false },
    size: { default: 'medium' },
    noTruncate: { type: Boolean, default: false },
    elipsizedTooltip: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

// Add ellipsis detection
const labelRef = ref<HTMLElement | null>(null);
const valueRef = ref<HTMLElement | null>(null);

const isLabelOverflowing = computed(() => {
  if (!labelRef.value) {
    return false;
  }
  return labelRef.value.scrollWidth > labelRef.value.clientWidth;
});

const isValueOverflowing = computed(() => {
  if (!valueRef.value) {
    return false;
  }
  return valueRef.value.scrollWidth > valueRef.value.clientWidth;
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["row display-property", `display-property-${_ctx.size}`])
    }, [
      (!_ctx.elipsizedTooltip)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["col iodine-label display-property-label", {'no-truncate': _ctx.noTruncate}]),
            ref_key: "labelRef",
            ref: labelRef
          }, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.label && _ctx.label.length > 8)
              ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.label), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.elipsizedTooltip)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "col iodine-label display-property-label",
            ref_key: "labelRef",
            ref: labelRef
          }, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (isLabelOverflowing.value && _ctx.label)
              ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.label), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 512))
        : _createCommentVNode("", true),
      (_ctx.horizontal)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "col display-property-value",
            ref_key: "valueRef",
            ref: valueRef
          }, [
            _createTextVNode(_toDisplayString(_ctx.value) + " ", 1),
            (_ctx.value && _ctx.value.length > 1)
              ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.value), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 512)), [
            [_vShow, !_ctx.loading]
          ])
        : _createCommentVNode("", true),
      (_ctx.horizontal)
        ? _withDirectives((_openBlock(), _createBlock(_component_q_skeleton, {
            key: 3,
            width: _ctx.loaderWidth || '50%'
          }, null, 8, ["width"])), [
            [_vShow, _ctx.loading]
          ])
        : _createCommentVNode("", true)
    ], 2),
    (!_ctx.horizontal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", {
            class: "col display-property-value",
            ref_key: "valueRef",
            ref: valueRef
          }, [
            _createTextVNode(_toDisplayString(_ctx.value) + " ", 1),
            (_ctx.value && (_ctx.elipsizedTooltip ? isValueOverflowing.value : _ctx.value.length > 6))
              ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.value), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !_ctx.loading]
          ]),
          (!_ctx.horizontal)
            ? _withDirectives((_openBlock(), _createBlock(_component_q_skeleton, {
                key: 0,
                width: _ctx.loaderWidth || '95%'
              }, null, 8, ["width"])), [
                [_vShow, _ctx.loading]
              ])
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})